import { FileOutlined, VideoCameraOutlined } from "shared/ui"
import { css, styled } from "styled-components"
import { FileImageOutlined, FilePdfOutlined } from "@ant-design/icons"

interface IAttachmentPreviewIconProps {
  type: string,
  className?: string
}

export const AttachmentPreviewIcon = ({ type, className }: IAttachmentPreviewIconProps) => {
  if (type.includes('image')) {
    return <SImageIcon className={className} />
  } else if (type.includes('video')) {
    return <SVideoIcon className={className} />
  } else if (type.includes('application/pdf')) {
    return <SPdfIcon className={className} />
  } else {
    return <SFileIcon className={className} />
  }
}

const iconStyles = css`
  font-size: 48px;
  color: #000000E0;
`

const SVideoIcon = styled(VideoCameraOutlined)`
  ${iconStyles}
`

const SPdfIcon = styled(FilePdfOutlined)`
  ${iconStyles}
`

const SFileIcon = styled(FileOutlined)`
  ${iconStyles}
`

const SImageIcon = styled(FileImageOutlined)`
  ${iconStyles}
`